import http from 'plugins/axios'

const BASE = '/ta/admin/tenant/welfare/experience-position'

export const RECORDS = {
  CURRENT_POSITION: { path: '/position/current', label: '当前仓位' },
  POSITION_HISTORY: { path: '/position/history', label: '仓位历史' },
  ORDER_HISTORY: { path: '/order/history', label: '成交历史' },
  CURRENT_ENTRUST: { path: '/entrust/current', label: '当前止盈止损' },
  ENTRUST_HISTORY: { path: '/entrust/history', label: '历史止盈止损' },
}

export default {
  list(recordType, data) {
    return http.get({ url: `${BASE}${RECORDS[recordType].path}`, data })
  },
  exportFile(data) {
    return http.get({ url: `${BASE}/export`, data, responseType: 'blob' })
  },
}
